import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { parseJSON } from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'deposit-paypal.component',
  templateUrl: '../sharedTemplates/deposit-paypal.component.html',
})
export class DepositPaypalComponent implements OnInit {
  DepositTypeId = 11;

  MinValue = 0;
  MaxValue = 0;

  coinbaseDatas: UntypedFormGroup;
  coinbaseDataRaw: any;
  firststep = true;
  statu = '0';

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      //orderid/:ordercode/:goapihash
      this.DepositTypeId = params['depositId'];
      this.getDepositInfo();
    });

    this.coinbaseDatas = _FormBuilder.group({
      amount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(5), Validators.min(10), Validators.max(10000)]),
    });
  }

  ngOnInit() {
    this.coinbaseDatas.valueChanges.subscribe(x => {
      this.coinbaseDataRaw = x;
    });

    this.route.params.subscribe(params => {
      //orderid/:ordercode/:goapihash
      this.statu = params['statu'];

      if (this.statu != '0') {
        if (window.self !== window.top) {
          // checking if it is an iframe
          window.parent.location.href = '/depositpaypal/' + this.statu;
        } else {
          if (this._UserHelper.customerUser.CustomerId) {
            this._ApiService.getClient2().then().catch();
          }
        }
      }
    });
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Paypal', true);
  }
  iframesrc;
  submitCoinbaseData() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.depositPaypal(this.coinbaseDatas.value.amount).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      //////console.warn("APco", result);
      const apcoresult = JSON.parse(result);
      //////console.warn( apcoresult.result);
      if (apcoresult.result == 'success') {
        //////console.warn(apcoresult.desc);
        //this.firststep = false;
        window.location = apcoresult.desc;
      } else {
        this._UiHelper.errorSnackBar(apcoresult.desc, '');
      }
    });
  }

  changeAmount(e) {
    this.coinbaseDatas.patchValue({ amount: e });
  }

  getDepositInfo() {
    this._ApiService.getAllDepositControl3().then(result => {
      //console.log("getDeposit--",result.filter(item => item.DepositTypeId == this.DepositTypeId));

      const depositInfo = result.filter(item => item.DepositTypeId == this.DepositTypeId);

      if (depositInfo == null || depositInfo.length == 0) {
        this.coinbaseDatas = this._FormBuilder.group({
          amount: new UntypedFormControl({ value: '', disabled: true }, [
            Validators.required,
            Validators.maxLength(5),
            Validators.min(this.MinValue),
            Validators.max(this.MaxValue),
          ]),
        });
      } else {
        this.MinValue = depositInfo[0].MinValue;
        this.MaxValue = depositInfo[0].MaxValue;

        if (depositInfo.length > 0) {
          this.coinbaseDatas = this._FormBuilder.group({
            amount: new UntypedFormControl({ value: '', disabled: false }, [
              Validators.required,
              Validators.maxLength(5),
              Validators.min(this.MinValue),
              Validators.max(this.MaxValue),
            ]),
          });
        }
      }
    });
  }
}
